import React from "react";

const SingleWorkBlock = ({ title, subtitle, isImage, image, imagePosition, coloredBG, leftIconWithText, rightIconWithText }) => {
    let textBlockClasses = "work-block--text";
    if(!isImage || image === "") {
        textBlockClasses += " work-block--text-full";
    }
    if(rightIconWithText && rightIconWithText.length > 0) {
        textBlockClasses += " work-block--inner-half";
    }

    return (
        <div className={"work-single--block" + (imagePosition !== "" ? " work-image-position--" + imagePosition : "")}>
            {(title !== "" || subtitle !== "") && (<div className="work-block--title">
                {title !== "" && (<h3>{title}</h3>)}
                {subtitle !== "" && (<p>{subtitle}</p>)}
            </div>)}
            <div className={"work-block--content" + (coloredBG ? " work-block--content-colored" : "")}>
                <div className={textBlockClasses}>
                    {leftIconWithText && leftIconWithText.length > 0 && (<div className="work-block--text-items">
                        {leftIconWithText.map((item, index) => (
                            <div key={index} className="work-block--text-item">
                                <div className="work-icon--image">
                                    <img src={item.icon} alt={item.title} />
                                </div>
                                <div className="work-icon--text">
                                    <h4>{item.title}</h4>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>)}
                    {rightIconWithText && rightIconWithText.length > 0 && (<div className="work-block--text-items">
                        {rightIconWithText.map((item, index) => (
                            <div key={index} className="work-block--text-item">
                                <div className="work-icon--image">
                                    <img src={item.icon} alt={item.title} />
                                </div>
                                <div className="work-icon--text">
                                    <h4>{item.title}</h4>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>)}
                </div>
                {isImage && image !== "" && (<div className="work-block--image">
                    <img src={image} alt={title} />
                </div>)}
            </div>
        </div>
    );
};

export default SingleWorkBlock;
